import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import {
  customerHasFeatureEnabled,
  customerHasMerchantSpringFeature,
  customerHasNotificationsFeatureEnabled,
} from '@app/core/utilities/customer.utilities';
import { Customer, CustomerFeature } from '../../models/customer.models';
import { Select } from '@ngxs/store';
import { CustomerState } from '@app/core/store/states/customer/customer.state';

@Injectable({
  providedIn: 'root',
})
export class CustomerFeatureGuardService implements CanActivate {
  @Select(CustomerState.customer)
  readonly customer$!: Observable<Customer>;

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.hasFeatureActive(route.data.feature);
  }

  private hasFeatureActive(featureType: CustomerFeature): Observable<boolean | UrlTree> {
    if (!featureType) {
      return of(true);
    }

    return this.customer$.pipe(
      map((customer) => {
        let hasFeature: boolean;

        switch (featureType) {
          case CustomerFeature.TriggerNotifications:
            hasFeature = customerHasNotificationsFeatureEnabled(customer);
            break;
          case CustomerFeature.MerchantSpring:
            hasFeature = customerHasMerchantSpringFeature(customer);
            break;
          default:
            hasFeature = customerHasFeatureEnabled(customer, featureType);
        }

        return hasFeature || this.router.createUrlTree(['/monitor'], { queryParamsHandling: 'preserve' });
      }),
    );
  }
}
